/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react'
import { apiPost } from 'tennders-stracture/libs/api'
import useSocket from 'tennders-common/hooks/useSocket'
import GHref from 'tennders-market/common/components/element/GHref'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import Trans from 'next-translate/Trans'
import IconBookmark from '../../../../../../icons/icon-bookmark.svg'
import IconBookmarked from '../../../../../../icons/icon-bookmarked.svg'

type Props = {
  transaction: TransactionType;
  color?: string
}
const RowFavouriteAction = ({ transaction, color }: Props) => {
  const [isFav, setisFav] = useState<boolean>(transaction?.isFavourite)
  const { setRefresh } = useSocket() // TODO: added refresh but would be better to find another way

  useEffect(() => {
    setisFav(transaction?.isFavourite)
  }, [transaction])

  const fav = async () => {
    setisFav(!isFav)
    await apiPost(`transactions/${transaction.id}/fav`, {})
    // setRefresh('all')
  }

  return (
    <GHref onClick={fav} className="d-flex col cell-icon flex-center">
      {isFav ? <IconBookmarked /> : <IconBookmark />}
      <div className="icon-label" style={{ color }}><Trans i18nKey="tableRow:bookmark" /></div>
    </GHref>
  )
}

export default RowFavouriteAction
